import React, { Suspense } from 'react';
import { DelayedLoader } from '@guildeducationinc/recess';
import { MaintenancePage } from 'src/components/MaintenancePage';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { OptimizelyProvider } from './OptimizelyProvider';
import { BookmarksProvider } from './BookmarksProvider';
import { RecommendationsProvider } from './RecommendationsProvider';
import { RecessProvider } from './RecessProvider';
import { SearchProvider } from './SearchProvider';
import { GqlProvider } from './GqlProvider';
import { ChatProvider } from './ChatDisplayProvider';
import { QuizProvider } from './QuizProvider';
import { ProductUsableProvider } from './ProductUsableProvider';

export const Providers: React.FC = ({ children }) => {
	const { userFromIdToken: user } = useMemberExperienceAuth();
	return (
		<Suspense fallback={<DelayedLoader label='Loading...' loaded={false} />}>
			<OptimizelyProvider user={user}>
				<RecessProvider>
					<MaintenancePage>
						<GqlProvider>
							<ProductUsableProvider>
								<SearchProvider>
									<BookmarksProvider>
										<RecommendationsProvider>
											<QuizProvider>
												<ChatProvider>{children}</ChatProvider>
											</QuizProvider>
										</RecommendationsProvider>
									</BookmarksProvider>
								</SearchProvider>
							</ProductUsableProvider>
						</GqlProvider>
					</MaintenancePage>
				</RecessProvider>
			</OptimizelyProvider>
		</Suspense>
	);
};
